export const ISO_COUNTRY_OPTIONS = [
  {
    "value": "IND",
    "label": "IND — India"
  },
  {
    "value": "ABW",
    "label": "ABW — Aruba"
  },
  {
    "value": "AFG",
    "label": "AFG — Afghanistan"
  },
  {
    "value": "AGO",
    "label": "AGO — Angola"
  },
  {
    "value": "AIA",
    "label": "AIA — Anguilla"
  },
  {
    "value": "ALA",
    "label": "ALA — Åland Islands"
  },
  {
    "value": "ALB",
    "label": "ALB — Albania"
  },
  {
    "value": "AND",
    "label": "AND — Andorra"
  },
  {
    "value": "ARE",
    "label": "ARE — United Arab Emirates"
  },
  {
    "value": "ARG",
    "label": "ARG — Argentina"
  },
  {
    "value": "ARM",
    "label": "ARM — Armenia"
  },
  {
    "value": "ASM",
    "label": "ASM — American Samoa"
  },
  {
    "value": "ATA",
    "label": "ATA — Antarctica"
  },
  {
    "value": "ATF",
    "label": "ATF — French Southern Territories"
  },
  {
    "value": "ATG",
    "label": "ATG — Antigua and Barbuda"
  },
  {
    "value": "AUS",
    "label": "AUS — Australia"
  },
  {
    "value": "AUT",
    "label": "AUT — Austria"
  },
  {
    "value": "AZE",
    "label": "AZE — Azerbaijan"
  },
  {
    "value": "BDI",
    "label": "BDI — Burundi"
  },
  {
    "value": "BEL",
    "label": "BEL — Belgium"
  },
  {
    "value": "BEN",
    "label": "BEN — Benin"
  },
  {
    "value": "BES",
    "label": "BES — Bonaire, Sint Eustatius and Saba"
  },
  {
    "value": "BFA",
    "label": "BFA — Burkina Faso"
  },
  {
    "value": "BGD",
    "label": "BGD — Bangladesh"
  },
  {
    "value": "BGR",
    "label": "BGR — Bulgaria"
  },
  {
    "value": "BHR",
    "label": "BHR — Bahrain"
  },
  {
    "value": "BHS",
    "label": "BHS — Bahamas"
  },
  {
    "value": "BIH",
    "label": "BIH — Bosnia and Herzegovina"
  },
  {
    "value": "BLM",
    "label": "BLM — Saint Barthélemy"
  },
  {
    "value": "BLR",
    "label": "BLR — Belarus"
  },
  {
    "value": "BLZ",
    "label": "BLZ — Belize"
  },
  {
    "value": "BMU",
    "label": "BMU — Bermuda"
  },
  {
    "value": "BOL",
    "label": "BOL — Bolivia, Plurinational State of"
  },
  {
    "value": "BRA",
    "label": "BRA — Brazil"
  },
  {
    "value": "BRB",
    "label": "BRB — Barbados"
  },
  {
    "value": "BRN",
    "label": "BRN — Brunei Darussalam"
  },
  {
    "value": "BTN",
    "label": "BTN — Bhutan"
  },
  {
    "value": "BVT",
    "label": "BVT — Bouvet Island"
  },
  {
    "value": "BWA",
    "label": "BWA — Botswana"
  },
  {
    "value": "CAF",
    "label": "CAF — Central African Republic"
  },
  {
    "value": "CAN",
    "label": "CAN — Canada"
  },
  {
    "value": "CCK",
    "label": "CCK — Cocos (Keeling) Islands"
  },
  {
    "value": "CHE",
    "label": "CHE — Switzerland"
  },
  {
    "value": "CHL",
    "label": "CHL — Chile"
  },
  {
    "value": "CHN",
    "label": "CHN — China"
  },
  {
    "value": "CIV",
    "label": "CIV — Côte d'Ivoire"
  },
  {
    "value": "CMR",
    "label": "CMR — Cameroon"
  },
  {
    "value": "COD",
    "label": "COD — Congo, The Democratic Republic of the"
  },
  {
    "value": "COG",
    "label": "COG — Congo"
  },
  {
    "value": "COK",
    "label": "COK — Cook Islands"
  },
  {
    "value": "COL",
    "label": "COL — Colombia"
  },
  {
    "value": "COM",
    "label": "COM — Comoros"
  },
  {
    "value": "CPV",
    "label": "CPV — Cabo Verde"
  },
  {
    "value": "CRI",
    "label": "CRI — Costa Rica"
  },
  {
    "value": "CUB",
    "label": "CUB — Cuba"
  },
  {
    "value": "CUW",
    "label": "CUW — Curaçao"
  },
  {
    "value": "CXR",
    "label": "CXR — Christmas Island"
  },
  {
    "value": "CYM",
    "label": "CYM — Cayman Islands"
  },
  {
    "value": "CYP",
    "label": "CYP — Cyprus"
  },
  {
    "value": "CZE",
    "label": "CZE — Czechia"
  },
  {
    "value": "DEU",
    "label": "DEU — Germany"
  },
  {
    "value": "DJI",
    "label": "DJI — Djibouti"
  },
  {
    "value": "DMA",
    "label": "DMA — Dominica"
  },
  {
    "value": "DNK",
    "label": "DNK — Denmark"
  },
  {
    "value": "DOM",
    "label": "DOM — Dominican Republic"
  },
  {
    "value": "DZA",
    "label": "DZA — Algeria"
  },
  {
    "value": "ECU",
    "label": "ECU — Ecuador"
  },
  {
    "value": "EGY",
    "label": "EGY — Egypt"
  },
  {
    "value": "ERI",
    "label": "ERI — Eritrea"
  },
  {
    "value": "ESH",
    "label": "ESH — Western Sahara"
  },
  {
    "value": "ESP",
    "label": "ESP — Spain"
  },
  {
    "value": "EST",
    "label": "EST — Estonia"
  },
  {
    "value": "ETH",
    "label": "ETH — Ethiopia"
  },
  {
    "value": "FIN",
    "label": "FIN — Finland"
  },
  {
    "value": "FJI",
    "label": "FJI — Fiji"
  },
  {
    "value": "FLK",
    "label": "FLK — Falkland Islands (Malvinas)"
  },
  {
    "value": "FRA",
    "label": "FRA — France"
  },
  {
    "value": "FRO",
    "label": "FRO — Faroe Islands"
  },
  {
    "value": "FSM",
    "label": "FSM — Micronesia, Federated States of"
  },
  {
    "value": "GAB",
    "label": "GAB — Gabon"
  },
  {
    "value": "GBR",
    "label": "GBR — United Kingdom"
  },
  {
    "value": "GEO",
    "label": "GEO — Georgia"
  },
  {
    "value": "GGY",
    "label": "GGY — Guernsey"
  },
  {
    "value": "GHA",
    "label": "GHA — Ghana"
  },
  {
    "value": "GIB",
    "label": "GIB — Gibraltar"
  },
  {
    "value": "GIN",
    "label": "GIN — Guinea"
  },
  {
    "value": "GLP",
    "label": "GLP — Guadeloupe"
  },
  {
    "value": "GMB",
    "label": "GMB — Gambia"
  },
  {
    "value": "GNB",
    "label": "GNB — Guinea-Bissau"
  },
  {
    "value": "GNQ",
    "label": "GNQ — Equatorial Guinea"
  },
  {
    "value": "GRC",
    "label": "GRC — Greece"
  },
  {
    "value": "GRD",
    "label": "GRD — Grenada"
  },
  {
    "value": "GRL",
    "label": "GRL — Greenland"
  },
  {
    "value": "GTM",
    "label": "GTM — Guatemala"
  },
  {
    "value": "GUF",
    "label": "GUF — French Guiana"
  },
  {
    "value": "GUM",
    "label": "GUM — Guam"
  },
  {
    "value": "GUY",
    "label": "GUY — Guyana"
  },
  {
    "value": "HKG",
    "label": "HKG — Hong Kong"
  },
  {
    "value": "HMD",
    "label": "HMD — Heard Island and McDonald Islands"
  },
  {
    "value": "HND",
    "label": "HND — Honduras"
  },
  {
    "value": "HRV",
    "label": "HRV — Croatia"
  },
  {
    "value": "HTI",
    "label": "HTI — Haiti"
  },
  {
    "value": "HUN",
    "label": "HUN — Hungary"
  },
  {
    "value": "IDN",
    "label": "IDN — Indonesia"
  },
  {
    "value": "IMN",
    "label": "IMN — Isle of Man"
  },
  {
    "value": "IOT",
    "label": "IOT — British Indian Ocean Territory"
  },
  {
    "value": "IRL",
    "label": "IRL — Ireland"
  },
  {
    "value": "IRN",
    "label": "IRN — Iran, Islamic Republic of"
  },
  {
    "value": "IRQ",
    "label": "IRQ — Iraq"
  },
  {
    "value": "ISL",
    "label": "ISL — Iceland"
  },
  {
    "value": "ISR",
    "label": "ISR — Israel"
  },
  {
    "value": "ITA",
    "label": "ITA — Italy"
  },
  {
    "value": "JAM",
    "label": "JAM — Jamaica"
  },
  {
    "value": "JEY",
    "label": "JEY — Jersey"
  },
  {
    "value": "JOR",
    "label": "JOR — Jordan"
  },
  {
    "value": "JPN",
    "label": "JPN — Japan"
  },
  {
    "value": "KAZ",
    "label": "KAZ — Kazakhstan"
  },
  {
    "value": "KEN",
    "label": "KEN — Kenya"
  },
  {
    "value": "KGZ",
    "label": "KGZ — Kyrgyzstan"
  },
  {
    "value": "KHM",
    "label": "KHM — Cambodia"
  },
  {
    "value": "KIR",
    "label": "KIR — Kiribati"
  },
  {
    "value": "KNA",
    "label": "KNA — Saint Kitts and Nevis"
  },
  {
    "value": "KOR",
    "label": "KOR — Korea, Republic of"
  },
  {
    "value": "KWT",
    "label": "KWT — Kuwait"
  },
  {
    "value": "LAO",
    "label": "LAO — Lao People's Democratic Republic"
  },
  {
    "value": "LBN",
    "label": "LBN — Lebanon"
  },
  {
    "value": "LBR",
    "label": "LBR — Liberia"
  },
  {
    "value": "LBY",
    "label": "LBY — Libya"
  },
  {
    "value": "LCA",
    "label": "LCA — Saint Lucia"
  },
  {
    "value": "LIE",
    "label": "LIE — Liechtenstein"
  },
  {
    "value": "LKA",
    "label": "LKA — Sri Lanka"
  },
  {
    "value": "LSO",
    "label": "LSO — Lesotho"
  },
  {
    "value": "LTU",
    "label": "LTU — Lithuania"
  },
  {
    "value": "LUX",
    "label": "LUX — Luxembourg"
  },
  {
    "value": "LVA",
    "label": "LVA — Latvia"
  },
  {
    "value": "MAC",
    "label": "MAC — Macao"
  },
  {
    "value": "MAF",
    "label": "MAF — Saint Martin (French part)"
  },
  {
    "value": "MAR",
    "label": "MAR — Morocco"
  },
  {
    "value": "MCO",
    "label": "MCO — Monaco"
  },
  {
    "value": "MDA",
    "label": "MDA — Moldova, Republic of"
  },
  {
    "value": "MDG",
    "label": "MDG — Madagascar"
  },
  {
    "value": "MDV",
    "label": "MDV — Maldives"
  },
  {
    "value": "MEX",
    "label": "MEX — Mexico"
  },
  {
    "value": "MHL",
    "label": "MHL — Marshall Islands"
  },
  {
    "value": "MKD",
    "label": "MKD — North Macedonia"
  },
  {
    "value": "MLI",
    "label": "MLI — Mali"
  },
  {
    "value": "MLT",
    "label": "MLT — Malta"
  },
  {
    "value": "MMR",
    "label": "MMR — Myanmar"
  },
  {
    "value": "MNE",
    "label": "MNE — Montenegro"
  },
  {
    "value": "MNG",
    "label": "MNG — Mongolia"
  },
  {
    "value": "MNP",
    "label": "MNP — Northern Mariana Islands"
  },
  {
    "value": "MOZ",
    "label": "MOZ — Mozambique"
  },
  {
    "value": "MRT",
    "label": "MRT — Mauritania"
  },
  {
    "value": "MSR",
    "label": "MSR — Montserrat"
  },
  {
    "value": "MTQ",
    "label": "MTQ — Martinique"
  },
  {
    "value": "MUS",
    "label": "MUS — Mauritius"
  },
  {
    "value": "MWI",
    "label": "MWI — Malawi"
  },
  {
    "value": "MYS",
    "label": "MYS — Malaysia"
  },
  {
    "value": "MYT",
    "label": "MYT — Mayotte"
  },
  {
    "value": "NAM",
    "label": "NAM — Namibia"
  },
  {
    "value": "NCL",
    "label": "NCL — New Caledonia"
  },
  {
    "value": "NER",
    "label": "NER — Niger"
  },
  {
    "value": "NFK",
    "label": "NFK — Norfolk Island"
  },
  {
    "value": "NGA",
    "label": "NGA — Nigeria"
  },
  {
    "value": "NIC",
    "label": "NIC — Nicaragua"
  },
  {
    "value": "NIU",
    "label": "NIU — Niue"
  },
  {
    "value": "NLD",
    "label": "NLD — Netherlands"
  },
  {
    "value": "NOR",
    "label": "NOR — Norway"
  },
  {
    "value": "NPL",
    "label": "NPL — Nepal"
  },
  {
    "value": "NRU",
    "label": "NRU — Nauru"
  },
  {
    "value": "NZL",
    "label": "NZL — New Zealand"
  },
  {
    "value": "OMN",
    "label": "OMN — Oman"
  },
  {
    "value": "PAK",
    "label": "PAK — Pakistan"
  },
  {
    "value": "PAN",
    "label": "PAN — Panama"
  },
  {
    "value": "PCN",
    "label": "PCN — Pitcairn"
  },
  {
    "value": "PER",
    "label": "PER — Peru"
  },
  {
    "value": "PHL",
    "label": "PHL — Philippines"
  },
  {
    "value": "PLW",
    "label": "PLW — Palau"
  },
  {
    "value": "PNG",
    "label": "PNG — Papua New Guinea"
  },
  {
    "value": "POL",
    "label": "POL — Poland"
  },
  {
    "value": "PRI",
    "label": "PRI — Puerto Rico"
  },
  {
    "value": "PRK",
    "label": "PRK — Korea, Democratic People's Republic of"
  },
  {
    "value": "PRT",
    "label": "PRT — Portugal"
  },
  {
    "value": "PRY",
    "label": "PRY — Paraguay"
  },
  {
    "value": "PSE",
    "label": "PSE — Palestine, State of"
  },
  {
    "value": "PYF",
    "label": "PYF — French Polynesia"
  },
  {
    "value": "QAT",
    "label": "QAT — Qatar"
  },
  {
    "value": "REU",
    "label": "REU — Réunion"
  },
  {
    "value": "ROU",
    "label": "ROU — Romania"
  },
  {
    "value": "RUS",
    "label": "RUS — Russian Federation"
  },
  {
    "value": "RWA",
    "label": "RWA — Rwanda"
  },
  {
    "value": "SAU",
    "label": "SAU — Saudi Arabia"
  },
  {
    "value": "SDN",
    "label": "SDN — Sudan"
  },
  {
    "value": "SEN",
    "label": "SEN — Senegal"
  },
  {
    "value": "SGP",
    "label": "SGP — Singapore"
  },
  {
    "value": "SGS",
    "label": "SGS — South Georgia and the South Sandwich Islands"
  },
  {
    "value": "SHN",
    "label": "SHN — Saint Helena, Ascension and Tristan da Cunha"
  },
  {
    "value": "SJM",
    "label": "SJM — Svalbard and Jan Mayen"
  },
  {
    "value": "SLB",
    "label": "SLB — Solomon Islands"
  },
  {
    "value": "SLE",
    "label": "SLE — Sierra Leone"
  },
  {
    "value": "SLV",
    "label": "SLV — El Salvador"
  },
  {
    "value": "SMR",
    "label": "SMR — San Marino"
  },
  {
    "value": "SOM",
    "label": "SOM — Somalia"
  },
  {
    "value": "SPM",
    "label": "SPM — Saint Pierre and Miquelon"
  },
  {
    "value": "SRB",
    "label": "SRB — Serbia"
  },
  {
    "value": "SSD",
    "label": "SSD — South Sudan"
  },
  {
    "value": "STP",
    "label": "STP — Sao Tome and Principe"
  },
  {
    "value": "SUR",
    "label": "SUR — Suriname"
  },
  {
    "value": "SVK",
    "label": "SVK — Slovakia"
  },
  {
    "value": "SVN",
    "label": "SVN — Slovenia"
  },
  {
    "value": "SWE",
    "label": "SWE — Sweden"
  },
  {
    "value": "SWZ",
    "label": "SWZ — Eswatini"
  },
  {
    "value": "SXM",
    "label": "SXM — Sint Maarten (Dutch part)"
  },
  {
    "value": "SYC",
    "label": "SYC — Seychelles"
  },
  {
    "value": "SYR",
    "label": "SYR — Syrian Arab Republic"
  },
  {
    "value": "TCA",
    "label": "TCA — Turks and Caicos Islands"
  },
  {
    "value": "TCD",
    "label": "TCD — Chad"
  },
  {
    "value": "TGO",
    "label": "TGO — Togo"
  },
  {
    "value": "THA",
    "label": "THA — Thailand"
  },
  {
    "value": "TJK",
    "label": "TJK — Tajikistan"
  },
  {
    "value": "TKL",
    "label": "TKL — Tokelau"
  },
  {
    "value": "TKM",
    "label": "TKM — Turkmenistan"
  },
  {
    "value": "TLS",
    "label": "TLS — Timor-Leste"
  },
  {
    "value": "TON",
    "label": "TON — Tonga"
  },
  {
    "value": "TTO",
    "label": "TTO — Trinidad and Tobago"
  },
  {
    "value": "TUN",
    "label": "TUN — Tunisia"
  },
  {
    "value": "TUR",
    "label": "TUR — Türkiye"
  },
  {
    "value": "TUV",
    "label": "TUV — Tuvalu"
  },
  {
    "value": "TWN",
    "label": "TWN — Taiwan, Province of China"
  },
  {
    "value": "TZA",
    "label": "TZA — Tanzania, United Republic of"
  },
  {
    "value": "UGA",
    "label": "UGA — Uganda"
  },
  {
    "value": "UKR",
    "label": "UKR — Ukraine"
  },
  {
    "value": "UMI",
    "label": "UMI — United States Minor Outlying Islands"
  },
  {
    "value": "URY",
    "label": "URY — Uruguay"
  },
  {
    "value": "USA",
    "label": "USA — United States"
  },
  {
    "value": "UZB",
    "label": "UZB — Uzbekistan"
  },
  {
    "value": "VAT",
    "label": "VAT — Holy See (Vatican City State)"
  },
  {
    "value": "VCT",
    "label": "VCT — Saint Vincent and the Grenadines"
  },
  {
    "value": "VEN",
    "label": "VEN — Venezuela, Bolivarian Republic of"
  },
  {
    "value": "VGB",
    "label": "VGB — Virgin Islands, British"
  },
  {
    "value": "VIR",
    "label": "VIR — Virgin Islands, U.S."
  },
  {
    "value": "VNM",
    "label": "VNM — Viet Nam"
  },
  {
    "value": "VUT",
    "label": "VUT — Vanuatu"
  },
  {
    "value": "WLF",
    "label": "WLF — Wallis and Futuna"
  },
  {
    "value": "WSM",
    "label": "WSM — Samoa"
  },
  {
    "value": "YEM",
    "label": "YEM — Yemen"
  },
  {
    "value": "ZAF",
    "label": "ZAF — South Africa"
  },
  {
    "value": "ZMB",
    "label": "ZMB — Zambia"
  },
  {
    "value": "ZWE",
    "label": "ZWE — Zimbabwe"
  }
];
